









const checkifValid = (path) => {
  const hasHttp = path.match('http') && path.match('http').index === 0;
  const hasSlash = path.match('/') && path.match('/').index === 0;
  const isLocal = path.match('localhost') && path.match('localhost').index === 0;

  return hasHttp || hasSlash || isLocal;
};

const getAddress = (newRoot, path) => {
  if (checkifValid(path)) {
    return `${newRoot}${path.replace(/^.*\/\/[^/]+/, '')}`;
  }
  return false;
};

class LinkUtility {





  iterateLinks(newRoot = 'https://secure.bankofamerica.com', anchorsToUpdate = document.querySelectorAll('a')) {
    [...anchorsToUpdate].forEach((anchorNode) => {
      const newHref = getAddress(newRoot, anchorNode.pathname);
      if (newHref) anchorNode.href = newHref + anchorNode.search + anchorNode.hash;
    });
  }






  collectLinks(container, queryString = 'a') {
    return [...container.querySelectorAll(`${queryString}[href]`)].map(anchor => anchor);
  }




  run() {
    if (!spaParams.siteParams.env.match(/prod/)) {
      const anchorsToUpdate = this.collectLinks(document.querySelector('body'), '[href*="https://secure.bankofamerica.com/"]');
      this.iterateLinks(spaParams.siteParams.secureHost, anchorsToUpdate);
    }
  }
}

export default (function SecureLinkUtility(util) {
  util.run();
}(new LinkUtility()));

